/**
 * Service Arrêts (Stops) - API Tracking
 * GET/POST /api/v1/stops/ , GET/PUT/PATCH/DELETE /api/v1/stops/{id}/
 */
import { createTrackingClient } from "../trackingApi";

export interface TrackingStop {
  id: string;
  route_id: string;
  name: string;
  latitude: string;
  longitude: string;
  order: number;
  created_at: string;
  updated_at: string;
}

export interface StopUpsertPayload {
  route_id: string;
  name: string;
  latitude: string | number;
  longitude: string | number;
  order: number;
}

function getClient(accessToken: string | undefined) {
  return createTrackingClient(accessToken);
}

export async function fetchTrackingStops(
  accessToken: string | undefined
): Promise<TrackingStop[]> {
  const client = getClient(accessToken);
  const { data } = await client.get<TrackingStop[] | { results: TrackingStop[] }>("/api/v1/stops/");
  if (Array.isArray(data)) return data;
  if (data && typeof data === "object" && "results" in data) return (data as { results: TrackingStop[] }).results;
  return [];
}

export async function createTrackingStop(
  accessToken: string | undefined,
  payload: StopUpsertPayload
): Promise<TrackingStop> {
  const client = getClient(accessToken);
  const { data } = await client.post<TrackingStop>("/api/v1/stops/", payload);
  return data;
}

export async function updateTrackingStop(
  accessToken: string | undefined,
  id: string,
  payload: StopUpsertPayload
): Promise<TrackingStop> {
  const client = getClient(accessToken);
  const { data } = await client.put<TrackingStop>(`/api/v1/stops/${id}/`, payload);
  return data;
}

export async function deleteTrackingStop(
  accessToken: string | undefined,
  id: string
): Promise<void> {
  const client = getClient(accessToken);
  await client.delete(`/api/v1/stops/${id}/`);
}
